import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import ContractFundingSearchFrameworkContract from "./ContractFundingSearchFrameworkContract";
import ContractFundingSearchKAE from "./ContractFundingSearchKAE";

export default class ContractFundingSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            funding_source: "",
            framework_contract_id: "",
            framework_contract_article_id: "",
        };

        this.handleFundingSourceChange = this.handleFundingSourceChange.bind(this);
    }

    componentWillMount() {
        let params = window.params;
        this.setState({
            funding_source: params.funding_source,
            kae_id: params.kae_id,
            framework_contract_id: params.framework_contract_id,
            framework_contract_article_id: params.framework_contract_article_id,
        });
    }

    handleFundingSourceChange(e) {
        this.setState({funding_source: e.target.value});
    }

    render() {
        let funding_element = null;
        if (this.state.funding_source === "kae") {
            funding_element = <ContractFundingSearchKAE id={this.state.kae_id}/>;
        } else if (this.state.funding_source === "framework_contract") {
            funding_element = <ContractFundingSearchFrameworkContract
                id={this.state.framework_contract_id}
                articleId={this.state.framework_contract_article_id}/>;
        } else if (this.state.funding_source === "general_account_codes") {

        }

        return (
            <div>
                <div className="form-group">
                    <label htmlFor="funding_source" className="col-md-4 control-label">
                        {window.__js_contracts.funding_source}
                    </label>
                    <div className="col-md-8">
                        <select name="funding_source"
                                id="funding_source"
                                className="form-control"
                                value={this.state.funding_source}
                                onChange={this.handleFundingSourceChange}>
                            <option value="">{window.__js_general.all}</option>
                            <option value="kae">{window.__js_contracts.kae}</option>
                            <option value="framework_contract">{window.__js_contracts.framework_contract}</option>
                            <option value="general_account_codes">{window.__js_contracts.general_account_codes}</option>
                            <option value="resources">{window.__js_contracts.resources}</option>
                            <option value="european">{window.__js_contracts.european}</option>
                        </select>
                    </div>
                </div>
                <br/>
                {funding_element}
            </div>
        );
    }
}

if (document.getElementById("contract-funding-search")) {
    let element = document.getElementById("contract-funding-search");
    ReactDOM.render(
        <ContractFundingSearch/>,
        element
    );
}